import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        USER: {
        },
        OPTIONS: {
            //local
            _local_lang: {
                type: 'zh',
                values: {
                    zh: '简体中文',
                    en: 'English',
                }
            },
            snackbar: {
                show: false,
                text: 'SNACKBAR',
                timeout: 6000,
                top: true,
                right: false,
                left: false,
                bottom: false,
                color: 'success'
            }
        },
        NAV: {
            drawer: false,
        },
        MAIN: {
            _main_banners: [
                {
                    title: "LADING...",
                }
            ],
            _main_announcements: [
                {
                    title: '公告标题',
                    content: '公告内容内容内容内容内容内容',
                    updatedAt: '2020-00-00',
                    actions: [
                        {
                            name: '点我前往',
                            link: '#'
                        }
                    ]
                },
                {
                    title: '公告标题2',
                    content: '22222公告内容内容内容内容内容内容',
                    updatedAt: '2020-00-00'
                },
            ]
        }
    },
    getters: {

    },
    mutations: {
        setOptions(s, p){
            s.OPTIONS += p
        },
        navDrawer(s) {
            s.NAV.drawer = !s.NAV.drawer
        },
        showSnackbar(s, p) {
            s.OPTIONS.snackbar.show = true;
            s.OPTIONS.snackbar.color = p.type;
            s.OPTIONS.snackbar.text = p.text;
        },
        func_saveUserInfo(s, p) {
            s.USER = p.USER;
        },
        func_setLanguage(s, p){
            s.OPTIONS._local_lang.type = p
        },
        initUserInfo(s, p){
            for(let item in p){
                if(item.indexOf('ms-user-') > -1){
                    s.USER[item.replace('ms-user-', '')] = p[item]
                }
            }
        },
    },
    actions: {
        saveUserAsync(c, p){
            var USER = Array;
            for(let item in p){
                window.localStorage.setItem(`ms-user-${item}`, p[item])
                USER[item] = p[item];
            }
            USER['authTime'] = new Date().getTime();
            c.commit('func_saveUserInfo', {USER});
        },
        setLang(c, p){
            c.commit('func_setLanguage', p)
        }
    }
})